/**
 *
 */
export enum Furnishings {
  Unfurnished = 2,
  Furnished = 4,
}
